import { Modal } from '@mui/material';
import { AppDocument } from 'api';
import Button from './Button';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import * as S from './ConfirmationModal.styled';

const DeleteDocumentConfirmationModal = ({
    open,
    mobile,
    document,
    toggleDeleteDocModal,
    handleDeleteDoc,
}: {
    open: boolean;
    mobile: boolean;
    document: AppDocument | null;
    toggleDeleteDocModal: () => void;
    handleDeleteDoc: (doc: AppDocument[]) => void;
}) => {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();
    return (
        <>
            {document && (
                <Modal sx={{ zIndex: '10000' }} open={open} onClose={() => toggleDeleteDocModal()}>
                    <S.ModalWrapper mobile={mobile}>
                        <S.Modal>
                            <S.ModalButtonWrapper>
                                <S.IconBtn onClick={() => toggleDeleteDocModal()}>
                                    <S.CrossSimpleIcon />
                                </S.IconBtn>
                            </S.ModalButtonWrapper>
                            <S.Container>
                                <S.Text> {t('areYouSureDeleteDoc', { lng: language })}</S.Text>

                                <S.ButtonContainer>
                                    <Button
                                        background="green"
                                        style={{ minWidth: '5rem' }}
                                        onClick={() => {
                                            handleDeleteDoc([document]);
                                            toggleDeleteDocModal();
                                        }}
                                    >
                                        {t('confirm', { lng: language })}
                                    </Button>
                                    <Button
                                        background="purple"
                                        style={{ minWidth: '5rem' }}
                                        onClick={() => toggleDeleteDocModal()}
                                    >
                                        {t('cancel', { lng: language })}
                                    </Button>
                                </S.ButtonContainer>
                            </S.Container>
                        </S.Modal>
                    </S.ModalWrapper>
                </Modal>
            )}
        </>
    );
};
export default DeleteDocumentConfirmationModal;
